/* AMPEL theme behaviour */
(function () {
  'use strict';

  /* 1. Sticky header solidifies on scroll */
  function headerSolidify() {
    var wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    var onScroll = function () {
      wrapper.classList.toggle('amp-solid', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 2. Reveal on scroll */
  function reveals() {
    var nodes = document.querySelectorAll('.amp-reveal');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var d = parseInt(en.target.getAttribute('data-delay') || '0', 10);
          setTimeout(function () { en.target.classList.add('is-in'); }, d);
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
    /* safety: never leave content hidden */
    setTimeout(function () {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
    }, 2800);
  }

  /* 3. AJAX add-to-cart for AMPEL collection cards */
  function updateCartBubble() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var icon = document.querySelector('#cart-icon-bubble');
        if (!icon) return;
        var bubble = icon.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          icon.appendChild(bubble);
        }
        bubble.innerHTML =
          '<span aria-hidden="true">' + (cart.item_count < 100 ? cart.item_count : '99+') + '</span>' +
          '<span class="visually-hidden">' + cart.item_count + '</span>';
      })
      .catch(function () {});
  }

  function ajaxAdd() {
    /* Mini size/colour dropdown on cards: show the choice, update the price, and
       stop "Add to cart" until an option is picked (one-size rings add instantly). */
    function syncPick(sel) {
      var form = sel.closest('form');
      var field = sel.closest('.amp-qa__field');
      var display = field && field.querySelector('[data-amp-display]');
      var opt = sel.options[sel.selectedIndex];
      var has = !!sel.value;
      if (display) display.textContent = has ? opt.textContent.trim() : (sel.getAttribute('data-amp-placeholder') || display.textContent);
      if (field) field.classList.toggle('has-value', has);
      var lbl = form && form.querySelector('[data-amp-lbl]');
      var price = has && opt.getAttribute('data-price');
      if (lbl && price) lbl.textContent = lbl.textContent.replace(/·.*$/, '· ' + price);
      if (has && form) {
        form.classList.remove('is-error');
        var hint = form.querySelector('[data-amp-hint]');
        if (hint) hint.hidden = true;
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-amp-variant]')) syncPick(e.target);
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-amp-add-btn]');
      if (!btn) return;
      var form = btn.closest('form[data-amp-add]');
      var sel = form && form.querySelector('[data-amp-variant]');
      if (!sel || sel.value) return;
      e.preventDefault();
      form.classList.remove('is-error');
      void form.offsetWidth;
      form.classList.add('is-error');
      var hint = form.querySelector('[data-amp-hint]');
      if (hint) hint.hidden = false;
      sel.focus({ preventScroll: true });
      if (typeof sel.showPicker === 'function') { try { sel.showPicker(); } catch (err) {} }
    });
    /* keep the dropdown text right if the browser restores a choice (back button) */
    document.querySelectorAll('[data-amp-variant]').forEach(function (sel) { if (sel.value) syncPick(sel); });
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-amp-variant]').forEach(function (sel) { if (sel.value) syncPick(sel); });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-amp-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-amp-add-btn]');
      var lbl = form.querySelector('[data-amp-lbl]');
      var prev = lbl ? lbl.textContent : '';
      /* ask Shopify for the refreshed cart drawer in the same request, so the drawer and progress bar update instantly */
      var drawer = document.querySelector('cart-drawer');
      var payload = { id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 };
      if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (data) {
          if (drawer && data && data.sections && data.sections['cart-drawer']) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else {
            updateCartBubble();
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'amp-card', productVariantId: payload.id, cartData: data });
          }
          if (lbl) lbl.textContent = form.getAttribute('data-amp-added-text') || 'Added to cart ✓';
          if (btn) btn.classList.add('is-added');
          setTimeout(function () {
            if (lbl) lbl.textContent = prev;
            if (btn) btn.classList.remove('is-added');
          }, 1400);
        })
        .catch(function () {
          /* graceful fallback: normal submit to /cart/add */
          form.removeAttribute('data-amp-add');
          form.submit();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      headerSolidify(); reveals(); ajaxAdd();
    });
  } else {
    headerSolidify(); reveals(); ajaxAdd();
  }
  document.addEventListener('shopify:section:load', reveals);
})();

/* ---------- Offer countdown (hero) ---------- */
(function(){
  var el=document.querySelector('[data-amp-count]');
  if(!el) return;
  var end=new Date(el.getAttribute('data-end'));
  if(isNaN(end)) return;
  var d=el.querySelector('[data-amp-d]'),h=el.querySelector('[data-amp-h]'),m=el.querySelector('[data-amp-m]'),s=el.querySelector('[data-amp-s]');
  function tick(){
    var diff=end-new Date();
    if(diff<=0){el.hidden=true;clearInterval(t);return;}
    el.hidden=false;
    var sec=Math.floor(diff/1000);
    d.textContent=Math.floor(sec/86400);
    h.textContent=Math.floor(sec%86400/3600);
    m.textContent=Math.floor(sec%3600/60);
    s.textContent=sec%60;
  }
  var t=setInterval(tick,1000); tick();
})();

/* ---------- Sticky add-to-cart bar (product pages, mobile-first) ----------
   Row 1: name, price, and (for sized rings) a size dropdown linked to the main size picker.
   Row 2: buyer's preferred express wallet (Apple Pay by default) + Add to cart. */
(function(){
  var submit=document.querySelector('.product-form__submit');
  var info=document.querySelector('product-info');
  if(!submit||!info) return;
  /* Use only the visible product name: the title block also holds a hidden duplicate link
     (for quick view) and the descriptive sub-line, which would otherwise repeat the name. */
  var title='';
  var h1=document.querySelector('.product__title h1')||document.querySelector('h1.product__title');
  if(h1){var c=h1.cloneNode(true);c.querySelectorAll('.amp-title-sub').forEach(function(n){n.remove();});title=c.textContent;}
  else{title=document.title.split('|')[0];}
  title=title.replace(/\s+/g,' ');
  var priceSel='.product .price__container .price-item--sale, .product .price__container .price-item--regular';
  var priceEl=document.querySelector(priceSel);
  var price=priceEl?priceEl.textContent.trim():'';
  var bar=document.createElement('div');
  bar.className='amp-sticky-atc';
  bar.innerHTML=
    '<div class="amp-sticky-atc__top">'+
      '<div class="amp-sticky-atc__meta"><span class="amp-sticky-atc__title"></span><span class="amp-sticky-atc__price"></span></div>'+
    '</div>'+
    '<div class="amp-sticky-atc__actions"><div class="amp-sticky-atc__wallet"></div><button type="button" class="amp-sticky-atc__btn">Add to cart</button></div>';
  bar.querySelector('.amp-sticky-atc__title').textContent=title.trim();
  bar.querySelector('.amp-sticky-atc__price').textContent=price;
  document.body.appendChild(bar);
  bar.querySelector('.amp-sticky-atc__btn').addEventListener('click',function(){
    submit.click();
    bar.classList.add('amp-sticky-atc--busy');
    setTimeout(function(){bar.classList.remove('amp-sticky-atc--busy');},1200);
  });

  /* ---- Size dropdown (only for rings that come in sizes; adjustable rings have none) ---- */
  var sizeData=null, sizeSelect=null;
  var sizeScript=document.querySelector('.amp-sticky-size-data');
  if(sizeScript){ try{ sizeData=JSON.parse(sizeScript.textContent); }catch(e){ sizeData=null; } }
  var sectionId=sizeScript?sizeScript.getAttribute('data-section'):null;
  var picker=sectionId?document.getElementById('variant-selects-'+sectionId):document.querySelector('product-info variant-selects');
  function pickerRoot(){ return (sectionId&&document.getElementById('variant-selects-'+sectionId))||picker; }
  /* match by trimmed name: the theme's option names can carry stray whitespace/newlines */
  function mainRadios(){
    var root=pickerRoot(); if(!root||!sizeData) return [];
    var want=(sizeData.name+'-'+sizeData.position).trim().toLowerCase();
    return Array.prototype.filter.call(root.querySelectorAll('input[type="radio"]'),function(r){ return (r.name||'').trim().toLowerCase()===want; });
  }
  function mainSelect(){
    var root=pickerRoot(); if(!root||!sizeData) return null;
    var want=('options['+sizeData.name+']').trim().toLowerCase();
    return Array.prototype.filter.call(root.querySelectorAll('select'),function(x){ return (x.name||'').replace(/\s+/g,' ').trim().toLowerCase()===want; })[0]||null;
  }
  if(sizeData&&sizeData.values&&sizeData.values.length>1&&(mainRadios().length||mainSelect())){
    var wrap=document.createElement('div');
    wrap.className='amp-sticky-atc__size';
    sizeSelect=document.createElement('select');
    sizeSelect.className='amp-sticky-atc__select';
    sizeSelect.setAttribute('aria-label','Ring size');
    sizeData.values.forEach(function(v){
      var o=document.createElement('option'); o.value=v; o.textContent='Size '+v; o.setAttribute('data-label','Size '+v); sizeSelect.appendChild(o);
    });
    wrap.appendChild(sizeSelect);
    if(document.getElementById('amp-size-cb')){
      var guide=document.createElement('label');
      guide.className='amp-sticky-atc__guide'; guide.setAttribute('for','amp-size-cb'); guide.textContent='Size guide';
      wrap.appendChild(guide);
    }
    bar.querySelector('.amp-sticky-atc__top').appendChild(wrap);
    bar.classList.add('amp-sticky-atc--sized');
    sizeSelect.addEventListener('change',function(){
      var val=sizeSelect.value;
      var radio=mainRadios().filter(function(r){return r.value.trim()===val;})[0];
      if(radio){ radio.click(); return; }
      var sel=mainSelect();
      if(sel){ sel.value=val; sel.dispatchEvent(new Event('change',{bubbles:true})); }
    });
  }
  function syncSize(){
    if(!sizeSelect) return;
    var current=null, unavailable={};
    var radios=mainRadios();
    if(radios.length){
      radios.forEach(function(r){ var v=r.value.trim(); if(r.checked) current=v; if(r.classList.contains('disabled')) unavailable[v]=true; });
    } else {
      var sel=mainSelect();
      if(sel){ current=sel.value; Array.prototype.forEach.call(sel.options,function(o){ if(o.disabled||/unavailable|sold out/i.test(o.textContent)) unavailable[o.value]=true; }); }
    }
    Array.prototype.forEach.call(sizeSelect.options,function(o){
      o.textContent=o.getAttribute('data-label')+(unavailable[o.value]?' - sold out':'');
    });
    if(current!==null) sizeSelect.value=current;
  }

  /* ---- Express wallet (Apple Pay / Shop Pay / Google Pay...) chosen by Shopify for this buyer ---- */
  var walletSrc=document.querySelector('.amp-sticky-wallet-src');
  var walletSlot=bar.querySelector('.amp-sticky-atc__wallet');
  var walletForm=walletSrc?walletSrc.querySelector('form'):null;
  var syncWallet=function(){};
  if(walletForm){
    var mainFormId=walletSrc.getAttribute('data-main-form');
    var wSection=walletSrc.getAttribute('data-section');
    walletSlot.appendChild(walletForm);
    walletSrc.parentNode.removeChild(walletSrc);
    bar.classList.add('amp-sticky-atc--wallet');
    var wId=walletForm.querySelector('input[name="id"]');
    var wQty=walletForm.querySelector('input[name="quantity"]');
    syncWallet=function(){
      var mainForm=document.getElementById(mainFormId);
      var mainId=mainForm?mainForm.querySelector('input[name="id"]'):null;
      if(mainId){wId.value=mainId.value;wId.disabled=mainId.disabled||!mainId.value;}
      var q=document.getElementById('Quantity-'+wSection)||document.querySelector('input[name="quantity"][form="'+mainFormId+'"]');
      if(q&&wQty){var n=parseInt(q.value,10);wQty.value=n>0?n:1;}
      bar.classList.toggle('amp-sticky-atc--nowallet',wId.disabled||submit.disabled);
    };
    /* final sync right before the wallet sheet opens (same tap, so Apple Pay still opens instantly) */
    walletSlot.addEventListener('pointerdown',syncWallet,true);
    walletSlot.addEventListener('keydown',syncWallet,true);
  } else {
    walletSlot.parentNode.removeChild(walletSlot);
  }

  function syncAll(){
    syncWallet(); syncSize();
    var p=document.querySelector(priceSel);
    if(p) bar.querySelector('.amp-sticky-atc__price').textContent=p.textContent.trim();
    var label=submit.querySelector('span');
    bar.querySelector('.amp-sticky-atc__btn').textContent=submit.disabled&&label?label.textContent.trim():'Add to cart';
    bar.classList.toggle('amp-sticky-atc--soldout',submit.disabled);
  }
  document.addEventListener('change',function(e){
    var t=e.target;
    if(t&&(t.name==='id'||t.name==='quantity'||(t.closest&&t.closest('variant-selects')))) setTimeout(syncAll,0);
  });
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.variantChange){
    subscribe(PUB_SUB_EVENTS.variantChange,function(){ setTimeout(syncAll,0); });
  }
  if('MutationObserver' in window){
    new MutationObserver(syncAll).observe(submit,{attributes:true,attributeFilter:['disabled']});
  }
  syncAll();

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){
      bar.classList.toggle('amp-sticky-atc--on',!en[0].isIntersecting);
    },{rootMargin:'-80px 0px 0px 0px'});
    io.observe(submit);
  } else {
    bar.classList.add('amp-sticky-atc--on');
  }
})();
